import { Icon } from 'cdui-js';

export const DiFiResult = (props) => {
  const {
    result = true,
    title = '成功',
    content = '测评成功',
    contentRender } = props;

  return (
    <div class="flex-column align-center justify-center gap-12px">
      {contentRender ? contentRender() :
        <div class="flex-column align-center justify-center">
          {!result ? (
            <Icon name="common-result-success" class="icon-s-XXL margin-b-L"></Icon>
          ) : (
            <Icon name="common-result-error" class="icon-s-XXL margin-b-L"></Icon>
          )}
          <div class="color-D font-s-L margin-b-XS" style="line-height: 25px;">{title}</div>
          <div class="color font-s-S" style="line-height: 20px;">{content}</div>
        </div>
      }
    </div >
  );
};